import React from 'react'
import Navbar from '../inc/Navbar'

import corporateshifting from "../images/Corporate Shifting.jpg";
import ScrollToTop from "react-scroll-to-top"
import { Link } from "react-router-dom";

function Aboutus() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />

      <ScrollToTop smooth top="100" color="Gray" />
      <div className='packermovershoogle'>
        <div className="album py-1">

          <div className="container mt-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">About Us</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className='packersnadia'>
        <br />
        <br />
        <div className="album py-1">
          <div className="container">
            <div className="row">
              <div className="col-md-7">

                <div className="card-body">
                  <h1 style={{ color: "#022046ff" }} className="card-title mb-3">Best Packers and Movers in India</h1>
                  <p style={{ color: "#05438e" }} className="card-text justify">AT India Packers Movers, we are proud to be recognized as one of the most trusted and affordable relocation service providers in India. With a clear focus on reliability, safety, and cost-effectiveness, we have been helping families and businesses move with ease and confidence. Why We’re Different:- 100% Client Satisfaction Rate, Transparent Pricing – No Hidden Costs, On-Time Delivery with Real-Time Tracking, Fully Insured & Damage-Free Relocation, Round-the-Clock Customer Assistance</p>
                  <p style={{ color: "#05438e" }} className='justify'>Whether it’s local shifting or interstate relocation, our team of trained professionals ensures that every item is packed, handled, and delivered with the utmost care. We combine modern logistics solutions with personalized service to offer seamless moving experiences—every time, at prices that fit your budget. </p>


                </div>
              </div>

              <div className="col-md-5">

                <img src={corporateshifting} className="card-img-top" alt="corporateshifting" />
              </div>

              <h2 className='mb-3'><b>Why Choose AT India Packers Movers?
              </b></h2>
              <h6 style={{ color: "#850031ff" }}> <b><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
              </svg> 100% Client Satisfaction Rate</b></h6>
              <p>We go above and beyond to exceed client expectations. Our dedication to delivering quality service has earned us a loyal customer base and repeat clients nationwide.</p>

              
              <h6 style={{ color: "#850031ff" }}> <b><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
              </svg> Transparent Pricing – No Hidden Costs</b></h6>
              <p>What we quote is what you pay. We maintain complete transparency in pricing, ensuring there are no last-minute surprises or extra charges.</p>


          
              <h6 style={{ color: "#850031ff" }}> <b><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
              </svg> On-Time Delivery with Real-Time Tracking</b></h6>
              <p>We value your time. Our logistics system is designed to ensure timely delivery, and our clients can track their belongings in real-time for complete peace of mind.</p>

             
              <h6 style={{ color: "#850031ff" }}> <b><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
              </svg> Fully Insured & Damage-Free Relocation</b></h6>
              <p>Have questions or need assistance? Our support team is available round-the-clock to assist you before, during, and after the relocation process.</p>
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>

    </div>
  )
}

export default Aboutus